import React from 'react';
import { Hero } from '../components/Hero';
import { OpeningLead } from '../components/OpeningLead';
import { PainPoints } from '../components/PainPoints';
import { TruthSection } from '../components/TruthSection';
import { WhyItFailed } from '../components/WhyItFailed';
import { MechanismReveal } from '../components/MechanismReveal';
import { WhatsIncluded } from '../components/WhatsIncluded';
import { WhoItsFor } from '../components/WhoItsFor';
import { OfferSection } from '../components/OfferSection';
import { FAQ } from '../components/FAQ';
import { FinalClose } from '../components/FinalClose';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans text-[#2C2C2C]" data-id="element-160">
      <Hero data-id="element-161" />
      <OpeningLead data-id="element-162" />
      <PainPoints data-id="element-163" />
      <TruthSection data-id="element-164" />
      <WhyItFailed data-id="element-165" />
      <MechanismReveal data-id="element-166" />
      <WhatsIncluded data-id="element-167" />
      <WhoItsFor data-id="element-168" />
      <OfferSection data-id="element-169" />
      <FAQ data-id="element-170" />
      <FinalClose data-id="element-171" />

      {/* Simple Footer */}
      <footer className="bg-[#2C2C2C] text-white py-8 text-center text-sm opacity-90" data-id="element-172">
        <p data-id="element-173">
          &copy; {new Date().getFullYear()} Menopausia Sin Caos. Todos los
          derechos reservados.
        </p>
      </footer>
    </div>;
}